const ITEMS = [
  "MOST-TEXTED FRIENDS",
  "WHO TEXTS FIRST",
  "REPLY SPEED",
  "YOUR DM PERSONALITY",
  "SAVAGE VERDICTS",
  "100% PRIVATE",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-white/[0.08] bg-panel py-4" aria-hidden="true">
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.25em] text-dim">
              {t}
            </span>
            <span className={`h-1.5 w-1.5 rounded-full ${i % 2 === 0 ? "bg-acid" : "bg-hot"}`} />
          </span>
        ))}
      </div>
    </div>
  );
}
